export default __webpack_public_path__ + "static/banner_toronto-432c90a02bde6fd6de3bc93d7df0bd47.webp";